/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerNoteAuthor
 */
export interface FreelancerNoteAuthor {
    /**
     * 
     * @type {string}
     * @memberof FreelancerNoteAuthor
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerNoteAuthor
     */
    accountId: string;
}

/**
 * Check if a given object implements the FreelancerNoteAuthor interface.
 */
export function instanceOfFreelancerNoteAuthor(value: object): value is FreelancerNoteAuthor {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    return true;
}

export function FreelancerNoteAuthorFromJSON(json: any): FreelancerNoteAuthor {
    return FreelancerNoteAuthorFromJSONTyped(json, false);
}

export function FreelancerNoteAuthorFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerNoteAuthor {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'accountId': json['accountId'],
    };
}

export function FreelancerNoteAuthorToJSON(value?: FreelancerNoteAuthor | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'accountId': value['accountId'],
    };
}

